import 'core-js/stable';
import 'regenerator-runtime/runtime';
import FontFaceObserver from 'fontfaceobserver';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app';
import logger from './utils/logger';

const MOUNT_NODE = document.getElementById('app');

const render = () => {
  const root = createRoot(MOUNT_NODE); // createRoot(container!) if you use TypeScript
  root.render(<App />);
};

const montserrat = new FontFaceObserver('Montserrat');
const openSans = new FontFaceObserver('Open Sans');

// eslint-disable-next-line @typescript-eslint/no-floating-promises
Promise.all([
  montserrat.load(),
  openSans.load(),
]).catch(() => {
  logger.warn('Fonts could not be loaded');
}).finally(() => {
  render();
});
